import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2, MapPin, CalendarDays, Ticket } from "lucide-react";
import { sr } from "../../lib/sr";

export default function SmartReachEvent() {
  const { slug } = useParams();
  const [ev, setEv] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    sr.ppPublicEvent(slug).then(setEv).catch(() => setErr("Event not found"));
  }, [slug]);

  const ink = "#0A121C", amber = "#F2A33D";
  if (err) return <Center><p style={{ color: "#fff" }}>{err}</p></Center>;
  if (!ev) return <Center><Loader2 className="sr-spin" color={amber} size={30} /></Center>;

  return (
    <div style={{ minHeight: "100vh", background: ink, color: "#fff", padding: 24, display: "flex", flexDirection: "column", alignItems: "center" }} data-testid="event-page">
      <div style={{ maxWidth: 560, width: "100%", textAlign: "center", marginTop: 40 }}>
        <span style={{ fontSize: 12, letterSpacing: 1, color: amber, fontWeight: 700 }}>SMARTREACH AT</span>
        <h1 style={{ fontSize: 34, margin: "8px 0" }} data-testid="event-name">{ev.name}</h1>
        <div style={{ display: "flex", gap: 16, justifyContent: "center", color: "#9fb0c3", fontSize: 14, flexWrap: "wrap" }}>
          {ev.city && <span style={{ display: "flex", gap: 6, alignItems: "center" }}><MapPin size={14} /> {ev.city}</span>}
          {ev.dates && <span style={{ display: "flex", gap: 6, alignItems: "center" }}><CalendarDays size={14} /> {ev.dates}</span>}
          {ev.booth && <span>Booth {ev.booth}</span>}
        </div>

        {ev.offer && (
          <div style={{ background: "#101C2C", border: `1px solid ${amber}`, borderRadius: 16, padding: 28, marginTop: 28 }}>
            <div style={{ fontSize: 46, fontWeight: 800, color: amber }} data-testid="event-value">{ev.offer.display_value}</div>
            <div style={{ fontSize: 18, fontWeight: 700, marginTop: 4 }}>{ev.offer.name}</div>
            {ev.offer.description && <p style={{ color: "#9fb0c3", fontSize: 14, marginTop: 8 }}>{ev.offer.description}</p>}
          </div>
        )}

        {ev.inventory ? (
          <p style={{ color: "#9fb0c3", fontSize: 14, marginTop: 16 }} data-testid="event-inventory">
            {ev.closed ? "This offer is now closed." : <><strong style={{ color: "#fff" }}>{ev.remaining}</strong> of {ev.inventory} credits remaining</>}
          </p>
        ) : null}

        {!ev.closed && (
          <Link to={ev.promotion_id ? `/smartreach-credit/` : "/signup"} data-testid="event-claim-btn"
            style={{ display: "inline-flex", alignItems: "center", gap: 8, marginTop: 20, background: amber, color: ink, fontWeight: 800, padding: "14px 28px", borderRadius: 999, textDecoration: "none" }}>
            <Ticket size={18} /> Find your business & claim
          </Link>
        )}
        <p style={{ color: "#6b7c90", fontSize: 12, marginTop: 24 }}>One eligible credit per business. SmartReach promotional credit has no cash value and may only be used toward eligible SmartReach services.</p>
      </div>
    </div>
  );
}

const Center = ({ children }) => (
  <div style={{ minHeight: "100vh", background: "#0A121C", display: "flex", alignItems: "center", justifyContent: "center" }}>{children}</div>
);
